export interface ProductDetailsCart {
  subtotalPrice: number;
  subtotalDiscountedPrice: number;
  subtotalDiscountedPoints?: number;
  subtotalPoints?: number;
  products: ProductCart[];
  /**
   * FCR 19.1 — backend gate (from `GET cart`): whether the cart may proceed to checkout under the
   * monthly order limit. When false, checkout is blocked and the adjustment flow (auto-reduce/remove)
   * runs instead. Optional so older responses stay valid.
   */
  isValidForCheckout?: boolean;
}

export interface ProductDetailsCartDto extends Omit<ProductDetailsCart, 'products'> {
  products: ProductCartDto[];
}

export const mapProductDetailsCartToInternal = (model: ProductDetailsCartDto): ProductDetailsCart => ({
  ...model,
  products: model.products.map((p) => ({ ...p, images: p.images.map((imageObj) => imageObj.sourceSet) })),
});

export interface ProductCart {
  quantity: number;
  isAvailable: boolean;
  productId: number;
  name: string;
  brandId: number;
  brandName: string;
  points: number;
  price: number;
  isPromo: boolean;
  discountedPrice: number;
  pointConversionRate?: number;
  estimatedShippingDays: string;
  images: Array<Array<string>>;
  attachedItem?: ProductCart[];
  visibleInCart?: boolean;
  lineNumber?: number;
  relatedLineNumber?: number;
  relatedParentProducts?: RelatedParentProduct[];
}

export interface ProductCartDto extends Omit<ProductCart, 'images'> {
  images: Array<{ sourceSet: string[] }>;
}

export interface ProductCartWithEngraving extends ProductCart {
  varianceSelections?: {
    options?: {
      selectedValue?: string;
    }[];
  };
  varianceSelectionsJson?: string;
}
export interface RelatedParentProduct {
  productId: number;
  name: string;
  partNumber: string;
  brandId: number;
  brandName: string;
  price: number;
  discountedPrice: number | null;
  isPromo: boolean;
  isTruckShip: boolean;
  images: string[];
  hasVariants: boolean;
}
